"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/file-xls.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M14 3l5.4 5.4v10.8a1.8 1.8 0 01-1.8 1.8H6.8A1.8 1.8 0 015 19.2V4.8C5 3.801 5.801 3 6.8 3H14zm-.9 6.3h4.95L13.1 4.35V9.3zm-5.467 7.784c0 .133.045.24.135.324.09.083.204.124.343.124a.49.49 0 00.346-.124.42.42 0 00.134-.324.426.426 0 00-.136-.328.487.487 0 00-.344-.126.483.483 0 00-.341.126.426.426 0 00-.137.328zm2.907-1.808l-.522-.946H9.11l.9 1.553-.941 1.617h.911l.562-.996.566.996h.908l-.94-1.617.902-1.553h-.905l-.533.946zm2.739 2.224V13h-.85v4.5h.85zm2.414-.876c0 .1-.042.18-.125.242-.083.061-.205.092-.367.092a.662.662 0 01-.416-.12.442.442 0 01-.167-.346h-.803c0 .192.059.37.176.535.117.165.279.295.485.39.206.094.441.142.707.142.393 0 .713-.09.961-.268a.827.827 0 00.372-.702c0-.404-.224-.689-.67-.853a3.673 3.673 0 00-.534-.142c-.21-.042-.36-.092-.45-.15-.089-.057-.133-.132-.133-.226 0-.1.04-.182.117-.246a.507.507 0 01.331-.097c.166 0 .288.04.366.119a.41.41 0 01.118.3h.846a.896.896 0 00-.361-.738c-.242-.19-.563-.285-.966-.285-.377 0-.682.095-.915.283a.871.871 0 00-.35.705c0 .482.377.803 1.13.96.227.048.392.1.494.16.103.06.154.142.154.245z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;